import { render, staticRenderFns } from "./ButtonRedirect.vue?vue&type=template&id=180abb67&scoped=true"
import script from "./ButtonRedirect.vue?vue&type=script&lang=js"
export * from "./ButtonRedirect.vue?vue&type=script&lang=js"
import style0 from "./ButtonRedirect.vue?vue&type=style&index=0&id=180abb67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180abb67",
  null
  
)

export default component.exports